import React, { useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import "./blogs.css";
import blog1 from "../assets/blog1-1.png";
import blog2 from "../assets/blog1-2.png";
function Blog1() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleMode = () => {
    setDarkMode(!darkMode);
  };
  return (
    <div className={`base-blog1 ${darkMode ? "dark" : "light"}`}>
      <div id="head-toggle-blog">
        <h1
          style={{
            textTransform: "initial",
            textDecoration: "underline",
            marginTop: "20px",
          }}
        >
          Journey Of Motherhood
        </h1>
        <div className="toggle-contents">
          <div
            className={`toggle-container ${darkMode ? "dark" : "light"}`}
            onClick={toggleMode}
          >
            <div className={`toggle-circle ${darkMode ? "dark" : "light"}`}>
              {darkMode ? (
                <FaMoon className="icon-blog moon" />
              ) : (
                <FaSun className="icon-blog sun" />
              )}
            </div>
          </div>
        </div>
      </div>
      <div id="blog-page-static">
        <p style={{ lineHeight: "1.5" }} className="blog-ps">
          “Motherhood,” It’s a journey unlike any other, full of unexpected
          twists, hilarious moments, and a whole lot of love. Whether you’re a
          first-time mom or welcoming another little one, one thing’s for sure:
          it’s an adventure that will take you places you never imagined! From
          the first signs of baby movement to the endless nights spent calming
          your little one to sleep, motherhood is a rollercoaster of emotions,
          experiences, and tears of joy!!!.
        </p>
        <h4>SURREAL MOMENT!</h4>
        <div style={{ padding: "10px 0px" }}>
          <p style={{ lineHeight: "1.5" }}  className="blog-ps">
            Wait, I’m Actually Growing a Human? The journey begins with those
            two pink lines on the test. Suddenly, you're Googling things like
            "Do’s and Don’ts during pregnancy" and wondering if you’ll ever fit
            into your pre-pregnancy clothes again. You’ll feel every little
            kick, burp, and hiccup as your baby grows, and you’ll wonder at how
            something so small can take over your entire world.
          </p>
        </div>
        <div style={{ padding: "0px 0px 10px 0px" }}>
          <p style={{ lineHeight: "1.5" }}>
            So, you’ve seen those two pink lines or had that magical moment
            where you’re holding the ultrasound picture in your hands. The
            excitement is REAL, Then it suddenly hits you - 'I’m going to be a
            parent!!! And then, reality sets in; you’ve got 10 months of
            pregnancy ahead. But don’t worry—this ride is going to be full of
            adventure.
          </p>
        </div>
      </div>

      <div className="flexie-blog">
        <div style={{ position: "relative" }}>
          <img src={blog1} alt="blog1-1st image" className="blog1-1" />
        </div>
        <div style={{ textAlign: "justify" }} id="right-image-cont">
          <h3>
            The First Trimester: The Excitement (and the Morning Sickness)
            Begins!
          </h3>
          <p>
            It’s the phase where everything is new, and you’re still wrapping
            your mind around the fact that you’re growing a tiny human. But,
            plot twist: your body’s idea of celebrating that miracle is by
            making you feel like you’ve been hit by a truck. Morning sickness?
            Check. Exhaustion? Check. Trying to figure out which foods actually
            sound appetizing? But hey, you’ve got this—just take it one snack at
            a time!
          </p>
          <h3>
            The Second Trimester: Baby Bump Glow (and Maybe Some Weird Cravings)
          </h3>
          <p>
            The second trimester is like a breath of fresh air. You’ve made it
            through the nausea, and now you’re feeling pretty great. Your baby
            bump is finally showing up (hello, adorable maternity clothes), and
            you’re starting to feel those little kicks. But wait did you
            suddenly crave pickles with peanut butter? Or maybe ice cream with
            hot sauce? Pregnancy cravings are REAL, and they’re here to keep you
            on your toes. But, oh, the glow, you’ve never felt so radiant!
          </p>
          <h3>The Third Trimester: Preparing for the Big Day </h3>
          <p>
            The final stretch! You’re getting closer to meeting your little one,
            and the anticipation is building. But, let’s be real—by now, you’ve
            mastered the art of waddling. You’re also becoming best friends with
            your maternity pillow and dreaming of the day you can sleep on your
            stomach again. The third trimester is a whirlwind of baby prep,
            frequent bathroom trips. But every ache and discomfort is worth it
            because you know that soon enough, you’ll be holding your little
            bundle of joy.
          </p>
        </div>
      </div>
      <div className="flxie-blog1">
        <div style={{ textAlign: "justify" }} id="right-image-cont">
          <h3>The Surreal Moment: Meeting Your Baby!</h3>
          <p>
            And it’s time. After months of anticipation, planning, and dreaming,
            you finally meet your baby. The surreal moment of seeing that tiny
            face for the first time is enough to make every second of pregnancy,
            every strange craving, every sleepless night, every stretch mark so
            totally worth it. Because in that instant, you realize that the
            journey was all part of getting you to this incredible new chapter
            of your life!!!
          </p>
          <h3>The First Few Months</h3>
          <p>
            Newborn life is a haze of diapers, feedings, and those precious baby
            snuggles. You’ll become a pro at surviving on just a few hours of
            sleep, and you’ll quickly learn that baby giggles are the best alarm
            clock. The baby blues? Totally normal, but with a little help from
            friends, family, and maybe a glass of wine (if that’s your thing),
            you’ll navigate this phase like a champ.
          </p>
          <h3>The Toddler Years: Time to Get Creative!</h3>
          <p>
            Just when you thought you had it all figured out, your baby turns
            into a toddler with their own agenda! You'll experience a
            rollercoaster of emotions! tantrums, and hilarious attempts at
            explaining why they can’t eat dirt. But there’s also the magic of
            first words, first steps, and endless cuddles. Every new milestone
            will make your heart swell with pride.
          </p>
          <h3>The Adventure Never Ends: Ready for the Next Chapter?</h3>
          <p>
            Motherhood isn’t a destination, it’s a never-ending adventure.
            You’ll face challenges, celebrate victories, and find joy in the
            smallest moments. It’s a journey that evolves as your child grows,
            but one thing remains constant: the love you feel for your little
            one.
          </p>
        </div>
        <div>
          <img src={blog2} alt="Blog1-2nd image" className="blog1-2" />
        </div>
      </div>
    </div>
  );
}

export default Blog1;
